import {
  motion,
  useTransform,
  useViewportScroll,
  Variants,
} from "framer-motion";
import { useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { TimelineAnimateScrollContext } from "../../context/TimlineAnimateScrollContext";
import { TimelineGroupData } from "../../mock/timeline";
import { Box } from "../Box";
import { Portal } from "../Portal";
import { Text } from "../Text";
import { TimelinePaginationItem } from "./TimelinePaginationItem";

interface TimelinePaginationProps {
  hidden?: boolean;
  items: TimelineGroupData[];
  activeIndex: number;
  theme: "light" | "dark";
}

const Wrapper = styled.div`
  position: fixed;
  z-index: 3;
  top: 50%;
  left: 32px;
  transform: translateY(-50%);
  display: none;

  ${({ theme }) => css`
    ${theme.mediaQueries.sm} {
      display: block;
    }
  `}
`;

const TextContainer = styled.div`
  position: absolute;
  top: -1.5em;
  left: 50%;
  transform: translateX(-50%);
`;

const paginationVariants: Variants = {
  hidden: {
    opacity: 0,
    // y: 20,
    // transformOrigin: "left",
  },
  visible: {
    opacity: 1,
    // y: 0,
    transition: { delay: 0, duration: 2, type: "tween" },
  },
};

export const TimelinePagination: React.FC<TimelinePaginationProps> = ({
  hidden,
  items,
  activeIndex,
  theme = "light",
}) => {
  const [state, setState] = useState<number[]>([]);
  const { setIsAnimating } = useContext(TimelineAnimateScrollContext);
  const { scrollY } = useViewportScroll();

  const handleClick = (id: number) => {
    if (document) {
      const el = document.getElementById(id.toString());

      if (el) {
        setIsAnimating({ isAnimating: true, color: items[id].bgColor });
        const offset = el.getBoundingClientRect().top;
        setTimeout(() => {
          window.scrollTo({ top: scrollY.get() + offset });
        }, 900);
      }
    }
  };

  useEffect(() => {
    setState(
      items.map((item, i) => {
        return i - activeIndex;
      })
    );
  }, [activeIndex, items]);

  return (
    <Portal>
      <Wrapper>
        <motion.div
          initial={false}
          animate={hidden ? "hidden" : "visible"}
          variants={paginationVariants}
        >
          <TextContainer>
            <Text
              variant="small"
              fontWeight={700}
              color={theme === "light" ? "white" : "blueDark"}
            >
              {items[activeIndex].startDate}
            </Text>
          </TextContainer>
          {state.map((state, i) => (
            <TimelinePaginationItem
              state={state}
              itemId={items[i].id}
              key={i}
              totalLength={items.length}
              onClick={() => handleClick(items[i].id)}
            >
              <Text variant="small" fontWeight={700}>
                {items[i].startDate}
              </Text>
            </TimelinePaginationItem>
          ))}
        </motion.div>
      </Wrapper>
    </Portal>
  );
};
